import {Component, ViewChild} from '@angular/core';
import {NovoCompromissoComponent} from "../../componentes/novo-compromisso/novo-compromisso.component";
import {DiarioComponent} from "../../componentes/diario/diario.component";
import {
  CadastroNovoAtendimentoComponent
} from "../../../../../core/componentes/cadastro-novo-atendimento/cadastro-novo-atendimento.component";
import {CalendarioComponent} from "../../../../../core/componentes/calendario/calendario.component";

@Component({
    selector: 'app-minha-agenda',
    templateUrl: './minha-agenda.component.html',
    styleUrl: './minha-agenda.component.css',
    standalone: false
})
export class MinhaAgendaComponent {
  @ViewChild(CadastroNovoAtendimentoComponent) novoAtendimento: CadastroNovoAtendimentoComponent;
  @ViewChild(NovoCompromissoComponent) novoCompromissoComponente: NovoCompromissoComponent;
  @ViewChild(DiarioComponent) diarioComponente: DiarioComponent;
  @ViewChild(CalendarioComponent) calendarioComponente: CalendarioComponent;
  loading = false;
  diario = false;
  mensal = true;
  semanal = false;

  abrirModalAtendimento(){
     this.novoAtendimento.showModal = true;
   }

  abrirModal(){
    this.novoCompromissoComponente.abrirModal();
  }

  atualizarListaDiario(){
    this.diarioComponente.buscarCompromissosDiario(new Date());
  }

  atualizarLista(){
    this.calendarioComponente.buscarTarefasDoMes();
  }

}
